import { DateRangeCustomFilterEnum as m } from "../enum/date-range-filter-enum.mjs";
import { setDateWithTimezone as l } from "../../../utils/date-time-format.mjs";
const D = (e) => Object.values(m).includes(
  e
), y = ({
  activeFilter: e,
  setDateRange: o,
  timezone: n,
  customFilters: u
}) => {
  var i;
  if (D(e)) {
    const t = (i = u.find((s) => s.slug === e)) == null ? void 0 : i.handler;
    t && o(t());
  } else
    switch (e) {
      case "last_30_days": {
        const t = l("", n);
        t.setHours(23, 59, 59, 999);
        const s = new Date(t);
        s.setDate(s.getDate() - 30), s.setHours(0, 0, 0, 0), o([s, t]);
        break;
      }
      case "this_month": {
        const t = l("", n), s = t.getFullYear(), a = t.getMonth(), r = new Date(s, a, 1), c = new Date(s, a + 1, 0);
        o([r, c]);
        break;
      }
      case "last_month": {
        const t = l("", n), s = t.getFullYear(), a = t.getMonth(), r = new Date(s, a - 1, 1), c = new Date(s, a, 0);
        o([r, c]);
        break;
      }
    }
};
export {
  y as setActiveFilterValue
};
